import React from 'react';

export default function WinProbability({ prediction, fighter1, fighter2 }) {
  if (!prediction || prediction.error) {
    return (
      <div className="card">
        <h2>Win Probability</h2>
        <div style={{ color: '#666', fontSize: 14 }}>
          {prediction?.error || 'Not enough data to generate a prediction.'}
        </div>
      </div>
    );
  }

  const f1Pct = Math.round(prediction.f1_win_prob * 100);
  const f2Pct = Math.round(prediction.f2_win_prob * 100);

  return (
    <div className="card">
      <h2>Win Probability</h2>

      {/* Split bar */}
      <div className="prob-names">
        <span>{fighter1?.full_name}</span>
        <span>{fighter2?.full_name}</span>
      </div>
      <div className="prob-bar-wrap">
        <div className="prob-bar-f1" style={{ width: `${f1Pct}%` }}>
          {f1Pct >= 20 && `${f1Pct}%`}
        </div>
        <div className="prob-bar-f2" style={{ width: `${f2Pct}%` }}>
          {f2Pct >= 20 && `${f2Pct}%`}
        </div>
      </div>
      <div className="prob-names" style={{ marginTop: 6 }}>
        <span style={{ color: '#e8372a', fontWeight: 700 }}>{f1Pct}%</span>
        <span style={{ color: '#2563eb', fontWeight: 700 }}>{f2Pct}%</span>
      </div>

      {/* Factor breakdown */}
      {prediction.factors?.length > 0 && (
        <>
          <div style={{ marginTop: 24, marginBottom: 10, fontSize: 12,
            textTransform: 'uppercase', letterSpacing: 1, color: '#666' }}>
            Key factors
          </div>
          {prediction.factors.map((factor, i) => (
            <div className="factor-row" key={i}>
              <span className="factor-label">{factor.label}</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 12, color: '#555' }}>
                  {factor.f1_value} vs {factor.f2_value}
                </span>
                <span className={`factor-adv ${
                  factor.advantage === 'fighter1' ? 'f1' :
                  factor.advantage === 'fighter2' ? 'f2' : 'even'
                }`}>
                  {factor.advantage === 'fighter1'
                    ? fighter1?.full_name?.split(' ')[1] || 'F1'
                    : factor.advantage === 'fighter2'
                    ? fighter2?.full_name?.split(' ')[1] || 'F2'
                    : 'Even'}
                </span>
              </div>
            </div>
          ))}
        </>
      )}

      {/* Style matchup note — passed via prediction.style_matchup if available */}
      {prediction.style_matchup && (
        <div style={{ marginTop: 16, padding: '10px 14px', background: '#1c1c28',
          borderRadius: 8, fontSize: 13, color: '#888' }}>
          Style matchup: <strong style={{ color: '#e8372a' }}>
            {prediction.style_matchup.f1_style}
          </strong> vs <strong style={{ color: '#2563eb' }}>
            {prediction.style_matchup.f2_style}
          </strong>
          {' '}— historically {Math.round(prediction.style_matchup.f1_style_win_pct * 100)}% win rate
          for {prediction.style_matchup.f1_style}.
        </div>
      )}
    </div>
  );
}
